import { PostWithdrawal, DeleteKey, GetUserStatus, PostAddKey, GetHistoryOperations } from './okxAffiliate.thunks'

export const okxCashbackAsyncActions = {
  GetUserStatus,
  PostAddKey,
  DeleteKey,
  GetHistoryOperations,
  PostWithdrawal,
}
